import React from "react";
import { ChangeEvent } from "react";
import { Link } from "react-router-dom";

import { apiGet } from "../../Api";
import withTitle from "../withTitle";

import HasRight from "../HasRight";
import ViewToolbar from "../ViewToolbar";

import "../../blocks.css";
import "../../icomoon.css";
import "../../indicator.css";
import "../../list.css";
import "../../spinner.css";
import "../../table.css";
import "../../user.css";
import "../viewer.css";

interface IRolesViewState {
    isLoading: boolean;
    error?: string;
    roles: any[];
    filteredRoles: any[];
    searchText: string;
}

class RolesView extends React.Component<{}, IRolesViewState> {
    constructor(props: Readonly<{}>) {
        super(props);

        this.state = {
            isLoading: false,
            roles: [],

            filteredRoles: [],
            searchText: ""
        };

        this.changeSearchChange = this.changeSearchChange.bind(this);
    }

    public async componentDidMount() {
        try {
            this.setState({
                error: undefined,
                isLoading: true
            });
            const roles = await apiGet<any[]>("roles");

            this.setState({
                filteredRoles: roles,
                isLoading: false,
                roles,
            });
        }
        catch (e) {
            this.setState({
                error: e.message,
                isLoading: false
            });
        }
    }

    public render() {
        return (
            <div className="viewer-root">
                <ViewToolbar>
                    <HasRight right="role:create">
                        <Link to="/roles/add" className="icon-plus" />
                    </HasRight>
                </ViewToolbar>
                <div className="filter-control-box">
                    <input type="search" className="fill-space" placeholder="Search..." value={this.state.searchText} onChange={this.changeSearchChange} />
                </div>

                <table className="table-vertical">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th className="col-smallest" />
                        </tr>
                    </thead>
                    <thead className="table-vertical-head-small">
                        <tr>
                            <th>Roles</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.state.isLoading ?
                                <tr>
                                    <td colSpan={10}>
                                        <div className="spinner-center lds-dual-ring" />
                                    </td>
                                </tr>
                                : this.state.filteredRoles.map(a => (
                                    <tr key={a.id}>
                                        <td data-caption="Name: ">{a.name}</td>
                                        <td>
                                            <HasRight right="role:write">
                                                <Link to={`/roles/${a.id}`} className="button small text-with-icon">
                                                    <span>Details</span>
                                                    <i className="icon-chevron-right" />
                                                </Link>
                                            </HasRight>
                                        </td>
                                    </tr>
                                ))
                        }
                    </tbody>
                </table>
            </div>
        );
    }

    private changeSearchChange(e: ChangeEvent<HTMLInputElement>) {
        const searchValue = e.currentTarget.value;
        this.setState(s => {
            return {
                searchText: searchValue,

                filteredRoles: searchValue ? s.roles.filter(u =>
                    u.name.toLowerCase().includes(searchValue.toLowerCase())
                ) : s.roles
            }
        });
    }
}

export default withTitle("Permission Roles", RolesView);
